import InvoiceRemark from './InvoiceRemark';
import type OrderInvoiceTuple from './OrderInvoiceTuple';

class OncePerIterationRemark extends InvoiceRemark implements OrderInvoiceTuple {
    NomenclatureNumber: string;
    ProcedureCode: string;
    Date: Date;
    PerIteration: number;
    OrderID: number;
    InvoiceID: number;
    InvoiceNumber: string;
    OrderNumber: string;
    RestrictionKey?: string;
    info(t: (key: string) => string): React.ReactElement {
        return this.InvoiceID
            ? (
                    <p>
                        {t('Nomenclature')}
                        {' '}
                        {this.NomenclatureNumber}
                        {' '}
                        {t('From')}
                        {' '}
                        {t('Procedure')}
                        {' '}
                        {this.ProcedureCode}
                        {' '}
                        {t(this.RestrictionKey ?? '').replace('{0}', this.PerIteration.toString())}
                        .
                        {t('HadThisNomenclature')}
                        {' '}
                        {t('NomenclatureRestrictionDay')}
                        {' '}
                        <a href={`/Orders/Detail/${this.OrderID}`} className="ajaxLinkNav">{t('Order')} #{this.OrderID}</a>
                        {' '}
                        <span>(</span>
                        <a href={`/Invoices/DetailConfirmed/${this.InvoiceID}`} className="ajaxLinkNav">{t('Invoice')} #{this.InvoiceID}</a>
                        <span>).</span>
                    </p>
                )
            : (
                    <p>
                        {t('OnlyOnceADayMultipleOnOrder').replace('{0}', this.NomenclatureNumber)}
                    </p>
                );
    }

    constructor(
        nomenclatureNumber: string,
        procedureCode: string,
        date: Date,
        perIteration: number,
        orderID: number,
        invoiceID: number,
        restrictionKey?: string,
        invoiceNumber = '',
        orderNumber = '',
    ) {
        super();
        this.NomenclatureNumber = nomenclatureNumber;
        this.ProcedureCode = procedureCode;
        this.Date = date;
        this.PerIteration = perIteration;
        this.OrderID = orderID;
        this.InvoiceID = invoiceID;
        this.InvoiceNumber = invoiceNumber;
        this.OrderNumber = orderNumber;
        this.RestrictionKey = restrictionKey;
    }
}

export default OncePerIterationRemark;
